import { LoadPanel } from 'devextreme-react/load-panel';
import { Tooltip } from 'devextreme-react/tooltip';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import Draggable from 'react-draggable';
import logo from '../../assets/images/custom/uklogo.jpg';
import api from '../../services/api-configuration-v2';


// Custom Modal Component
const CustomModal = ({ isOpen, onClose, children }) => {
    const [isAnimating, setIsAnimating] = useState(false);
    const [shouldRender, setShouldRender] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {

        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (isOpen) {
            setShouldRender(true);
            document.body.style.overflow = 'hidden';
            requestAnimationFrame(() => setIsAnimating(true));
        } else {
            setIsAnimating(false);
            document.body.style.overflow = '';
            const timer = setTimeout(() => setShouldRender(false), 300);
            return () => clearTimeout(timer);
        }
    }, [isOpen]);

    if (!shouldRender) return null;

    const isFullscreen = !!document.fullscreenElement;
    const targetElement = isFullscreen ? document.fullscreenElement : document.body;

    return createPortal(
        <div className={`modal-wrapper ${isAnimating ? 'modal-visible' : ''} ${isMobile ? 'mobile' : ''}`}>
            <div className="modal-backdrop" onClick={onClose} />
            <div className="modal-box">
                {children}
            </div>
        </div>,
        targetElement
    );
};

/**
 * Canlı Operasyon Takip Component
 */
const OperasyonTakip = () => {
    const [liveData, setLiveData] = useState([
        {
            id: 23,
            name: "HAYDARPAŞA LİMANI",
            summary: {
                toplam: "...",
                regions: [
                    { name: "PDI", value: "..." },
                    { name: "PERON", value: "..." },
                    { name: "RESEPSİYON", value: "..." },
                    { name: "STOK", value: "..." }
                ]
            },
            stats: {
                faturasiz: "...",
                blokajli: "...",
                grupajEkrani: "...",
                hazirlaniyor: "..."
            },
            regions: {
                regions: [
                    { name: "İst. Asya", value: "..." },
                    { name: "İst. Av", value: "..." },
                    { name: "Anadolu", value: "..." },
                    { name: "Depo Trans.", value: "..." }
                ],
                toplam: "..."
            },
            pdi: {
                plan: "...",
                giris: "...",
                cikis: "...",
                toplamCik: "..."
            }
        },
        {
            id: 26,
            name: "İZMİT DEPO",
            summary: {
                toplam: "...",
                regions: [
                    { name: "PDI", value: "..." },
                    { name: "PERON", value: "..." },
                    { name: "RESEPSİYON", value: "..." },
                    { name: "STOK", value: "..." }
                ]
            },
            stats: {
                faturasiz: "...",
                blokajli: "...",
                grupajEkrani: "...",
                hazirlaniyor: "..."
            },
            regions: {
                regions: [
                    { name: "İst. Asya", value: "..." },
                    { name: "İst. Av", value: "..." },
                    { name: "Anadolu", value: "..." },
                    { name: "Depo Trans.", value: "..." }
                ],
                toplam: "..."
            },
            pdi: {
                plan: "...",
                giris: "...",
                cikis: "...",
                toplamCik: "..."
            }
        }
    ]);
    const containerRef = useRef(null);
    const intervalRef = useRef(null);
    const [showScrollTop, setShowScrollTop] = useState(false);
    const [isDragging, setIsDragging] = useState(false);
    const [dragStartTime, setDragStartTime] = useState(0);
    const [hasError, setHasError] = useState(false);

    const animationConfig = {
        show: {
            type: 'fade',
            from: { opacity: 0 },
            to: { opacity: 1 }
        },
        hide: {
            type: 'fade',
            from: { opacity: 1 },
            to: { opacity: 0 }
        }
    };

    // Function to fetch fresh data
    const fetchData = async () => {
        try {
            const response = await api.post('/getLiveOperationTrackingByWarehouseID', {
                warehouse_ids: [23, 26]
            });
            if (response.data) {
                // API'den gelen veriyi dönüştür
                const transformedData = response.data.map(depot => ({
                    id: depot.id,
                    name: depot.name,
                    summary: {
                        toplam: depot.toplam,
                        regions: depot.summary
                    },
                    stats: {
                        faturasiz: depot.stats.faturasiz,
                        blokajli: depot.stats.blokajli,
                        grupajEkrani: depot.stats.grupaj || 0,
                        hazirlaniyor: depot.stats.hazirlaniyor
                    },
                    regions: {
                        regions: [
                            { name: "İst. Asya", value: depot.door_exit.istanbulAsya },
                            { name: "İst. Av", value: depot.door_exit.istanbulAvrupa },
                            { name: "Anadolu", value: depot.door_exit.anadolu },
                            { name: "Depo Trans.", value: depot.door_exit.depoTransfer }
                        ],
                        toplam: depot.door_exit.toplam
                    },
                    pdi: {
                        plan: depot.pdi.plan,
                        giris: depot.pdi.giris,
                        cikis: depot.pdi.cikis,
                        toplamCik: depot.pdi.toplamCik
                    }
                }));
                setLiveData(transformedData);
                setHasError(false);
            }
            await new Promise(resolve => setTimeout(resolve, 500));
            fetchData();
            // İstek tamamlandıktan sonra 500ms bekle
        } catch (error) {
            console.error('Veri çekme hatası:', error);
            setHasError(true);
            // Hata durumunda da 500ms bekle
            await new Promise(resolve => setTimeout(resolve, 3000));
            fetchData();

        } finally {

        }
    };

    // Start/stop data refresh
    const startDataRefresh = () => {
        if (!intervalRef.current) {
            intervalRef.current = setInterval(() => {
                const pdfButton = document.getElementById('pdf-download-button');
                if (!pdfButton || !pdfButton.disabled) {
                    // fetchData();
                }
            }, 3000);
        }
    };

    const stopDataRefresh = () => {
        if (intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }
    };

    // Auto-refresh data every 3 seconds
    useEffect(() => {
        if (document.querySelector(".page-main-header")) document.querySelector(".page-main-header").classList.add('open');
        if (document.querySelector(".page-sidebar")) document.querySelector(".page-sidebar").classList.add('open');

        let isComponentMounted = true;

        const fetchDataWithCheck = async () => {
            if (!isComponentMounted) return;

            try {
                const response = await api.post('/getLiveOperationTrackingByWarehouseID', {
                    warehouse_ids: [23, 26]
                });

                if (!isComponentMounted) return;

                if (response.data) {
                    const transformedData = response.data.map(depot => ({
                        id: depot.id,
                        name: depot.name,
                        summary: {
                            toplam: depot.toplam,
                            regions: depot.summary
                        },
                        stats: {
                            faturasiz: depot.stats.faturasiz,
                            blokajli: depot.stats.blokajli,
                            grupajEkrani: depot.stats.grupaj || 0,
                            hazirlaniyor: depot.stats.hazirlaniyor
                        },
                        regions: {
                            regions: [
                                { name: "İst. Asya", value: depot.door_exit.istanbulAsya },
                                { name: "İst. Av", value: depot.door_exit.istanbulAvrupa },
                                { name: "Anadolu", value: depot.door_exit.anadolu },
                                { name: "Depo Trans.", value: depot.door_exit.depoTransfer }
                            ],
                            toplam: depot.door_exit.toplam
                        },
                        pdi: {
                            plan: depot.pdi.plan,
                            giris: depot.pdi.giris,
                            cikis: depot.pdi.cikis,
                            toplamCik: depot.pdi.toplamCik
                        }
                    }));
                    setLiveData(transformedData);
                    setHasError(false);
                }

                if (isComponentMounted) {
                    await new Promise(resolve => setTimeout(resolve, 500));
                    fetchDataWithCheck();
                }
            } catch (error) {
                console.error('Veri çekme hatası:', error);
                if (isComponentMounted) {
                    setHasError(true);
                    await new Promise(resolve => setTimeout(resolve, 3000));
                    fetchDataWithCheck();
                }
            }
        };

        fetchDataWithCheck();
        startDataRefresh();

        return () => {
            isComponentMounted = false;
            stopDataRefresh();
            if (document.querySelector(".page-main-header")) document.querySelector(".page-main-header").classList.remove('open');
            if (document.querySelector(".page-sidebar")) document.querySelector(".page-sidebar").classList.remove('open');
        };
    }, []);


    // Handle PDF download
    const handlePdfDownload = async () => {
        const pdfButton = document.getElementById('pdf-download-button');
        const loadPanel = document.getElementById('pdf-load-panel');

        if (pdfButton.disabled || !containerRef.current) return;

        pdfButton.disabled = true;
        pdfButton.innerHTML = `
            <i class="fa fa-spinner fa-spin"></i>
            <span class="button-text">İndiriliyor...</span>
        `;
        loadPanel.style.display = 'block';
        stopDataRefresh();

        setTimeout(async () => {
            try {
                const pdfContainer = document.createElement('div');
                pdfContainer.style.position = 'absolute';
                pdfContainer.style.left = '-9999px';
                pdfContainer.style.width = '1600px';
                pdfContainer.style.backgroundColor = '#FFFFFF';
                pdfContainer.style.padding = '20px 40px';
                document.body.appendChild(pdfContainer);

                const pdfContent = document.createElement('div');
                pdfContent.className = 'pdf-content';
                pdfContainer.appendChild(pdfContent);

                const header = document.createElement('div');
                header.className = 'pdf-header';

                const logoImg = document.createElement('img');
                logoImg.src = logo;
                logoImg.alt = 'UK Lojistik';
                logoImg.style.width = '60px';
                logoImg.style.height = '60px';

                header.innerHTML = `
                    <div class="pdf-header-content">
                        <div class="pdf-logo-section">
                            <div class="pdf-logo"></div>
                            <div class="pdf-company-info">
                                <div>info@uklojistik.com</div>
                                <div>www.uklojistik.com</div>
                                <div>+90 (216) 688 08 98</div>
                            </div>
                        </div>
                        <div class="pdf-date-section">
                            <div class="pdf-date-label">Rapor Tarihi</div>
                            <div class="pdf-date-value">${moment().format('DD.MM.YYYY HH:mm:ss')}</div>
                        </div>
                    </div>
                    <div class="pdf-title">CANLI OPERASYON TAKİP RAPORU</div>
                `;

                const logoContainer = header.querySelector('.pdf-logo');
                logoContainer.appendChild(logoImg);
                pdfContent.appendChild(header);

                // Add depot content for PDF
                const depotsContainer = document.createElement('div');
                depotsContainer.className = 'pdf-depots-container';

                liveData.forEach(depot => {
                    const depotSection = document.createElement('div');
                    depotSection.className = 'pdf-depot-section';
                    depotSection.innerHTML = `
                        <div class="pdf-depot-title">${depot.name}</div>
                        <div class="pdf-depot-content">
                            <div class="pdf-summary-card">
                                <div class="pdf-summary-header">Toplam ${depot.summary.toplam}</div>
                                <div class="pdf-summary-grid">
                                    ${depot.summary.regions.map(region => `<div class="pdf-region-item">${region.name}<br>${region.value}</div>`).join('')}
                                </div>
                            </div>
                            <div class="pdf-stats-section">
                                <div class="pdf-stat-item">Faturasız: ${depot.stats.faturasiz}</div>
                                <div class="pdf-stat-item">Blokajlı: ${depot.stats.blokajli}</div>
                                <div class="pdf-stat-item">Grupaj Ekranı: ${depot.stats.grupajEkrani}</div>
                                <div class="pdf-stat-item">Hazırlanıyor: ${depot.stats.hazirlaniyor}</div>
                            </div>
                        </div>
                        <div class="pdf-date">13 Mayıs 2025</div>
                        <div class="pdf-bottom-section">
                            <div class="pdf-regions-card">
                                <div class="pdf-regions-grid">
                                    ${depot.regions.regions.map(region => `<div class="pdf-region-item">${region.name}<br>${region.value}</div>`).join('')}
                                </div>
                            </div>
                            <div class="pdf-pdi-section">
                                <div class="pdf-pdi-title">PDI</div>
                                <div class="pdf-pdi-item">Plan: ${depot.pdi.plan}</div>
                                <div class="pdf-pdi-item">Giriş: ${depot.pdi.giris}</div>
                                <div class="pdf-pdi-item">Çıkış: ${depot.pdi.cikis}</div>
                                <div class="pdf-pdi-item">Toplam Çık.: ${depot.pdi.toplamCik}</div>
                            </div>
                        </div>
                    `;
                    depotsContainer.appendChild(depotSection);
                });

                pdfContent.appendChild(depotsContainer);

                const canvas = await html2canvas(pdfContainer, {
                    scale: 2,
                    useCORS: true,
                    allowTaint: true,
                    backgroundColor: '#FFFFFF',
                    logging: false,
                    width: 1600,
                    height: pdfContainer.scrollHeight
                });

                const imgData = canvas.toDataURL('image/jpeg', 1.0);
                const pdf = new jsPDF({
                    orientation: 'landscape',
                    unit: 'mm',
                    format: 'a4',
                    compress: true
                });

                const pdfWidth = pdf.internal.pageSize.getWidth();
                const pdfHeight = pdf.internal.pageSize.getHeight();
                const imgWidth = canvas.width;
                const imgHeight = canvas.height;
                const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);

                const imgX = (pdfWidth - imgWidth * ratio) / 2;
                const imgY = (pdfHeight - imgHeight * ratio) / 2;

                pdf.addImage(imgData, 'JPEG', imgX, imgY, imgWidth * ratio, imgHeight * ratio);
                pdf.save(`UK-Lojistik-Canli-Operasyon-Takip-${moment().format('YYYYMMDD-HHmm')}.pdf`);

                document.body.removeChild(pdfContainer);
            } catch (error) {
                console.error('PDF oluşturma hatası:', error);
                alert('PDF oluşturulurken bir hata oluştu. Lütfen tekrar deneyin.');
            } finally {
                const pdfButton = document.getElementById('pdf-download-button');
                const loadPanel = document.getElementById('pdf-load-panel');

                pdfButton.disabled = false;
                pdfButton.innerHTML = `
                    <i class="fa fa-file-pdf-o"></i>
                    <span class="button-text">PDF İndir</span>
                `;
                loadPanel.style.display = 'none';
                startDataRefresh();
            }
        }, 0);
    };

    // Function to scroll to top
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    // Handle drag functions
    const handleDragStart = () => {
        setDragStartTime(Date.now());
        setIsDragging(false);
    };

    const handleDrag = () => {
        setIsDragging(true);
    };

    const handleDragStop = () => {
        const dragDuration = Date.now() - dragStartTime;
        if (!isDragging && dragDuration < 200) {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }
        setIsDragging(false);
    };

    // Handle scroll to show/hide scroll to top button
    useEffect(() => {
        const handleScroll = () => {
            setShowScrollTop(window.pageYOffset > 150);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <>
            <div className="page-container p-4" ref={containerRef} style={{
                maxWidth: "2000px",
                margin: "auto",
                backgroundColor: "#F6F7FB",
                position: "relative",
                zIndex: "1"
            }}>
                <LoadPanel
                    id="pdf-load-panel"
                    position={{ of: '.page-container' }}
                    visible={false}
                    showIndicator={true}
                    shading={true}
                    showPane={true}
                    style={{ display: 'none' }}
                />

                {/* Live Operations Content */}
                <div className={`live-circle-indicator ${hasError ? 'error' : ''}`} id="liveIndicator"></div>

                <Tooltip
                    target="#liveIndicator"
                    showEvent="mouseenter"
                    hideEvent="mouseleave"
                    position="top"
                    animation={animationConfig}
                    hideOnOutsideClick={false}
                >
                    <div style={{
                        padding: '0px',
                        fontSize: '13px'
                    }}>{hasError ? 'Bağlantı Hatası' : 'Sistem Aktif'}</div>
                </Tooltip>

                <div className="depots-container">
                    {liveData.map(depot => (
                        <div key={depot.id} className="operations-depot-section">
                            <div className="operations-depot-container">
                                {/* Left Side - Summary Card and Stats */}
                                <div className="operations-left-section">
                                    <h2 className="depot-title">{depot.name}</h2>

                                    <div className="summary-stats-row">
                                        {/* Blue Summary Card */}
                                        <div className="summary-card">
                                            <div className="summary-header">
                                                <div className="summary-total">Toplam</div>
                                                <div className={`summary-total-value ${depot.summary.toplam === "..." ? "loading" : ""}`}>
                                                    {depot.summary.toplam === "..." ? "" : depot.summary.toplam}
                                                </div>
                                            </div>
                                            {
                                                depot.summary.toplam == "..." ? (
                                                    <>
                                                        <div className="summary-grid loading">
                                                            <div className="summary-item">
                                                                <div className="summary-label"></div>
                                                                <div className="summary-value loading"></div>
                                                            </div>
                                                            <div className="summary-item">
                                                                <div className="summary-label"></div>
                                                                <div className="summary-value loading"></div>
                                                            </div>
                                                            <div className="summary-item">
                                                                <div className="summary-label"></div>
                                                                <div className="summary-value loading"></div>
                                                            </div>
                                                            <div className="summary-item">
                                                                <div className="summary-label"></div>
                                                                <div className="summary-value loading"></div>
                                                            </div>
                                                        </div>
                                                    </>
                                                ) : (
                                                    <div className="summary-grid">
                                                        {(() => {
                                                            const visibleRegions = [...depot.summary.regions]
                                                                .filter(region => {
                                                                    if (region.value === "..." || parseInt(region.value) === 0) return false;
                                                                    return true;
                                                                })
                                                                .sort((a, b) => {
                                                                    const valueA = parseInt(a.value) || 0;
                                                                    const valueB = parseInt(b.value) || 0;
                                                                    return valueB - valueA;
                                                                });

                                                            // En fazla bölge sayısını bul
                                                            const maxRegions = Math.max(...liveData.map(d =>
                                                                d.summary.regions.filter(r => r.value !== "..." && parseInt(r.value) !== 0).length
                                                            ));

                                                            // Eksik bölge sayısını hesapla
                                                            const emptyRegionsNeeded = maxRegions - visibleRegions.length;

                                                            // Boş bölgeleri ekle
                                                            const allRegions = [
                                                                ...visibleRegions,
                                                                ...Array(emptyRegionsNeeded).fill({ name: "", value: "" })
                                                            ];

                                                            return allRegions.map((region, index) => (
                                                                <div key={index} className={`summary-item ${!region.name ? 'empty' : ''}`}>
                                                                    <div className="summary-label">{region.name}</div>
                                                                    <div className={`summary-value ${region.value === "..." ? "loading" : ""}`}>
                                                                        {region.value === "..." ? "" : region.value}
                                                                    </div>
                                                                </div>
                                                            ));
                                                        })()}
                                                    </div>
                                                )}
                                        </div>

                                        {/* Right Stats */}
                                        <div className="right-stats-section my-auto">
                                            <div className="stat-row">
                                                <div className="stat-label">Faturasız:</div>
                                                <div className={`stat-value ${depot.stats.faturasiz === "..." ? "loading" : ""}`}>
                                                    {depot.stats.faturasiz === "..." ? "" : depot.stats.faturasiz}
                                                </div>
                                            </div>
                                            <div className="stat-row">
                                                <div className="stat-label">Blokajlı:</div>
                                                <div className={`stat-value ${depot.stats.blokajli === "..." ? "loading" : ""}`}>
                                                    {depot.stats.blokajli === "..." ? "" : depot.stats.blokajli}
                                                </div>
                                            </div>
                                            <div className="stat-row">
                                                <div className="stat-label">Grupaj Ekranı:</div>
                                                <div className={`stat-value ${depot.stats.grupajEkrani === "..." ? "loading" : ""}`}>
                                                    {depot.stats.grupajEkrani === "..." ? "" : depot.stats.grupajEkrani}
                                                </div>
                                            </div>
                                            <div className="stat-row">
                                                <div className="stat-label">Hazırlanıyor:</div>
                                                <div className={`stat-value ${depot.stats.hazirlaniyor === "..." ? "loading" : ""}`}>
                                                    {depot.stats.hazirlaniyor === "..." ? "" : depot.stats.hazirlaniyor}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Date Section */}
                            <div className="date-section">
                                <h3 className="date-title">{moment(new Date()).format('DD MMMM YYYY')}</h3>
                            </div>

                            {/* Bottom Section - Regions and PDI */}
                            <div className="bottom-section">
                                {/* Light Blue Regions Card */}
                                <div className="regions-card">
                                    <div className="regions-grid">
                                        <div className="region-item header">
                                            <div className="region-label">Bölge</div>
                                            <div className="region-value">Sevk</div>
                                        </div>
                                        {depot.regions.regions.map(region => (
                                            <div key={region.name} className="region-item">
                                                <div className="region-label">{region.name}</div>
                                                <div className={`region-value ${region.value === "..." ? "loading" : ""}`}>
                                                    {region.value === "..." ? "" : region.value}
                                                </div>
                                            </div>
                                        ))}
                                        <div className="region-item total">
                                            <div className="region-label">Toplam</div>
                                            <div className={`region-value ${depot.regions.toplam === "..." ? "loading" : ""}`}>
                                                {depot.regions.toplam === "..." ? "" : depot.regions.toplam}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* PDI Section */}
                                <div className="pdi-section">
                                    <div className="pdi-title">PDI</div>
                                    <div className="pdi-stats">
                                        <div className="pdi-row">
                                            <div className="pdi-label">Plan</div>
                                            <div className={`pdi-value ${depot.pdi.plan === "..." ? "loading" : ""}`}>
                                                {depot.pdi.plan === "..." ? "" : depot.pdi.plan}
                                            </div>
                                        </div>
                                        <div className="pdi-row">
                                            <div className="pdi-label">Giriş</div>
                                            <div className={`pdi-value ${depot.pdi.giris === "..." ? "loading" : ""}`}>
                                                {depot.pdi.giris === "..." ? "" : depot.pdi.giris}
                                            </div>
                                        </div>
                                        <div className="pdi-row">
                                            <div className="pdi-label">Çıkış</div>
                                            <div className={`pdi-value ${depot.pdi.cikis === "..." ? "loading" : ""}`}>
                                                {depot.pdi.cikis === "..." ? "" : depot.pdi.cikis}
                                            </div>
                                        </div>
                                        <div className="pdi-row">
                                            <div className="pdi-label">Toplam Çık.</div>
                                            <div className={`pdi-value ${depot.pdi.toplamCik === "..." ? "loading" : ""}`}>
                                                {depot.pdi.toplamCik === "..." ? "" : depot.pdi.toplamCik}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Styles */}
                <style jsx>{`
                    .page-container {
                        position: relative;
                        font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
                    }
                    
                    .header-section {
                        background-color: white;
                        border-radius: 8px;
                        padding: 16px 20px;
                        box-shadow: none;
                        font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
                        border: 1px solid #e9ecef;
                        overflow: visible;
                        position: relative;
                    }
                    
                    .header-content {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        gap: 16px;
                        width: 100%;
                        margin-bottom: 0;
                        flex-wrap: wrap;
                    }
                    
                    .header-top-row {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        width: 100%;
                        margin-bottom: 12px;
                        order: 1;
                    }
                    
                    .header-left-group {
                        display: flex;
                        align-items: center;
                        gap: 12px;
                        flex: 1;
                        min-width: 0;
                        order: 2;
                    }
                    
                    .header-logo-container {
                        flex-shrink: 0;
                        width: 44px;
                        height: 44px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }
                    
                    .header-logo {
                        width: auto;
                        height: 65px;
                        object-fit: contain;
                        padding: 2px;
                    }
                    
                    .brand-filter-container {
                        flex: 1;
                        min-width: 200px;
                        max-width: 300px;
                    }
                    
                    .action-buttons {
                        display: flex;
                        gap: 8px;
                        flex-shrink: 0;
                        align-items: center;
                        order: 4;
                    }
                    
                    .action-button {
                        height: 40px;
                        padding: 0 16px;
                        border: none;
                        border-radius: 8px;
                        font-size: 14px;
                        font-weight: 500;
                        display: inline-flex;
                        align-items: center;
                        justify-content: center;
                        gap: 8px;
                        transition: all 0.2s ease;
                        cursor: pointer;
                        background: #f1f5f9;
                        color: #64748b;
                        white-space: nowrap;
                        font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
                        position: relative;
                        overflow: hidden;
                    }
                    
                    .action-button:hover {
                        background: #e2e8f0;
                        color: #475569;
                        transform: translateY(-1px);
                    }
                    
                    .fullscreen-button {
                        background: #f1f5f9;
                        color: #64748b;
                        padding: 0;
                        width: 40px;
                        min-width: 40px;
                        border: none;
                        font-size: 16px;
                    }
                    
                    .pdf-button {
                        background: #f1f5f9;
                        color: #64748b;
                        min-width: 40px !important;
                        width: auto;
                        border: none;
                        font-size: 14px;
                    }
                    
                    .pdf-button:disabled {
                        opacity: 0.6;
                        cursor: not-allowed;
                        transform: none;
                        background: #f1f5f9;
                    }

                    /* Operations Specific Styles */
                    .depots-container {
                        display: flex;
                        gap: 30px;
                        justify-content: center;
                        align-items: flex-start;
                        flex-wrap: wrap;
                        max-width: 1900px;
                        margin: 0 auto;
                        padding: 0 10px;
                    }

                    .operations-depot-section {
                        background: white;
                        border-radius: 12px;
                        padding: 0;
                        border: 2px solid #dee2e6;
                        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
                        overflow: hidden;
                        flex: 1;
                        min-width: 550px;
                        max-width: 100%;
                        margin-bottom: 20px;
                    }

                    .operations-depot-container {
                        padding: 15px;
                    }

                    .depot-title {
                        font-size: 1.6rem;
                        font-weight: 700;
                        color: #2B53C6;
                        margin-bottom: 20px;
                        text-align: center;
                        padding: 15px 0;
                        border-bottom: 2px solid #f0f0f0;
                        word-wrap: break-word;
                        hyphens: auto;
                    }

                    .summary-stats-row {
                        display: flex;
                        gap: 15px;
                        align-items: stretch;
                    }

                    /* Blue Summary Card */
                    .summary-card {
                        background: linear-gradient(135deg, #2B53C6 0%, #1e40af 100%);
                        color: white;
                        border-radius: 12px;
                        padding: 15px;
                        flex: 1;
                        width: 100%;
                        max-width: 350px;
                        display: flex;
                        flex-direction: column;
                    }

                    .summary-header {
                        text-align: center;
                        margin-bottom: 12px;
                        border-bottom: 1px solid rgba(255, 255, 255, 0.3);
                        padding-bottom: 8px;
                        flex-shrink: 0;
                    }

                    .summary-total {
                        font-size: 1.1rem;
                        opacity: 0.9;
                        margin-bottom: 5px;
                    }

                    .summary-total-value {
                        font-size: 2rem;
                        font-weight: 600;
                        position: relative;
                    }

                    .summary-total-value.loading {
                        min-width: 20px;
                        display: inline-block;
                    }

                    .summary-total-value.loading::after {
                        content: '';
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        width: 20px;
                        aspect-ratio: 4;
                        --_g: no-repeat radial-gradient(circle closest-side,#ffffff 90%,#0000);
                        background: 
                            var(--_g) 0%   50%,
                            var(--_g) 50%  50%,
                            var(--_g) 100% 50%;
                        background-size: calc(100%/3) 100%;
                        animation: l7 1s infinite linear;
                    }

                    .summary-grid {
                        display: grid;
                        grid-template-columns: 1fr 1fr;
                        gap: 12px;
                        flex: 1;
                    }

                    .summary-item {
                        text-align: center;
                        padding: 8px;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        min-height: 60px;
                    }

                    .summary-item.empty {
                        visibility: hidden;
                    }

                    .summary-label {
                        font-size: 0.9rem;
                        opacity: 0.8;
                        margin-bottom: 5px;
                        word-break: break-word;
                        hyphens: auto;
                    }

                    .summary-value {
                        font-size: 1.3rem;
                        font-weight: 600;
                        position: relative;
                    }

                    .summary-value.loading {
                        position: relative;
                        min-width: 20px;
                        display: inline-block;
                        height: 4rem;
                    }

                    .summary-value.loading::after {
                        content: '';
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        width: 20px;
                        aspect-ratio: 4;
                        --_g: no-repeat radial-gradient(circle closest-side,#ffffff 90%,#0000);
                        background: 
                            var(--_g) 0%   50%,
                            var(--_g) 50%  50%,
                            var(--_g) 100% 50%;
                        background-size: calc(100%/3) 100%;
                        animation: l7 1s infinite linear;
                    }

                    .summary-value.loading::after {
                        content: '';
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        width: 20px;
                        aspect-ratio: 4;
                        --_g: no-repeat radial-gradient(circle closest-side,#ffffff 90%,#0000);
                        background: 
                            var(--_g) 0%   50%,
                            var(--_g) 50%  50%,
                            var(--_g) 100% 50%;
                        background-size: calc(100%/3) 100%;
                        animation: l7 1s infinite linear;
                    }

                    @keyframes l7 {
                        33%{background-size:calc(100%/3) 0%  ,calc(100%/3) 100%,calc(100%/3) 100%}
                        50%{background-size:calc(100%/3) 100%,calc(100%/3) 0%  ,calc(100%/3) 100%}
                        66%{background-size:calc(100%/3) 100%,calc(100%/3) 100%,calc(100%/3) 0%  }
                    }
                    .loading {
                        padding: 1rem 0rem;
                        opacity: 0.5;
                    }
                    /* Right Stats Section */
                    .right-stats-section {
                        flex: 1;
                        max-width: 350px;
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;
                    }

                    .stat-row {
                        display: flex;
                        justify-content: space-between;
                        padding: 15px 0;
                        border-bottom: 1px solid #f0f0f0;
                        min-height: 60px;
                    }

                    .stat-row:last-child {
                        border-bottom: none;
                    }

                    .stat-label {
                        font-size: 1rem;
                        color: #495057;
                    }

                    .stat-value {
                        font-size: 1.1rem;
                        font-weight: 600;
                        color: #212529;
                        position: relative;
                    }

                    .stat-value.loading {
                        position: relative;
                        min-width: 20px;
                        display: inline-block;
                    }

                    .stat-value.loading::after {
                        content: '';
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        width: 20px;
                        aspect-ratio: 4;
                        --_g: no-repeat radial-gradient(circle closest-side,#2B53C6 90%,#0000);
                        background: 
                            var(--_g) 0%   50%,
                            var(--_g) 50%  50%,
                            var(--_g) 100% 50%;
                        background-size: calc(100%/3) 100%;
                        animation: l7 1s infinite linear;
                    }

                    /* Date Section */
                    .date-section {
                        text-align: center;
                        padding: 15px;
                        border-top: 1px solid #e9ecef;
                        border-bottom: 1px solid #e9ecef;
                        background: #f8f9fa;
                    }

                    .date-title {
                        font-size: 1.2rem;
                        font-weight: 600;
                        color: #212529;
                        margin: 0;
                    }

                    /* Bottom Section */
                    .bottom-section {
                        display: flex;
                        gap: 15px;
                        padding: 15px;
                        align-items: flex-start;
                    }

                    /* Light Blue Regions Card */
                    .regions-card {
                        background: linear-gradient(135deg, #60a5fa 0%, #3b82f6 100%);
                        color: white;
                        border-radius: 12px;
                        padding: 15px;
                        flex: 1;
                        max-width: 350px;
                        width: 100%;
                    }

                    .regions-grid {
                        display: flex;
                        flex-direction: column;

                    }

                    .region-item {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        padding: 1px 0;
                    }

                    .region-item.header {
                        border-bottom: 1px solid rgba(255, 255, 255, 0.3);
                        margin-bottom: 5px;
                        font-weight: 600;
                    }

                    .region-item.total {
                        border-top: 1px solid rgba(255, 255, 255, 0.3);
                        margin-top: 5px;
                        padding-top: 12px;
                        font-weight: 700;
                    }

                    .region-label {
                        font-size: 1.1rem;
                        opacity: 0.9;
                    }

                    .region-value {
                        font-size: 1.2rem;
                        font-weight: 600;
                        position: relative;
                    }

                    .region-value.loading {
                        position: relative;
                        min-width: 20px;
                        display: inline-block;
                    }

                    .region-value.loading::after {
                        content: '';
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        width: 20px;
                        aspect-ratio: 4;
                        --_g: no-repeat radial-gradient(circle closest-side,#ffffff 90%,#0000);
                        background: 
                            var(--_g) 0%   50%,
                            var(--_g) 50%  50%,
                            var(--_g) 100% 50%;
                        background-size: calc(100%/3) 100%;
                        animation: l7 1s infinite linear;
                    }

                    .region-item.total .region-label,
                    .region-item.total .region-value {
                        font-size: 1.3rem;
                        font-weight: 700;
                    }

                    /* PDI Section */
                    .pdi-section {
                        flex: 1;
                        max-width: 350px;
                    }

                    .pdi-title {
                        font-size: 1.3rem;
                        font-weight: 600;
                        color: #212529;
                        margin-bottom: 15px;
                        text-align: center;
                    }

                    .pdi-row {
                        display: flex;
                        justify-content: space-between;
                        padding: 10px 0;
                        border-bottom: 1px solid #f0f0f0;
                    }

                    .pdi-label {
                        font-size: 1rem;
                        color: #495057;
                    }

                    .pdi-value {
                        font-size: 1.1rem;
                        font-weight: 600;
                        color: #212529;
                        position: relative;
                    }

                    .pdi-value.loading {
                        position: relative;
                        min-width: 20px;
                        display: inline-block;
                    }

                    .pdi-value.loading::after {
                        content: '';
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        width: 20px;
                        aspect-ratio: 4;
                        --_g: no-repeat radial-gradient(circle closest-side,#2B53C6 90%,#0000);
                        background: 
                            var(--_g) 0%   50%,
                            var(--_g) 50%  50%,
                            var(--_g) 100% 50%;
                        background-size: calc(100%/3) 100%;
                        animation: l7 1s infinite linear;
                    }

                    /* Responsive Design */
                    @media (max-width: 1300px) {
                        .depots-container {
                            flex-direction: column;
                            align-items: center;
                        }
                        
                        .operations-depot-section {
                            max-width: 1000px;
                            min-width: auto;
                            width: 100%;
                        }
                    }

                    @media (max-width: 768px) {
                        .summary-stats-row {
                            flex-direction: column;
                        }

                        .summary-card,
                        .right-stats-section {
                            max-width: none;
                            width: 100%;
                        }

                        .bottom-section {
                            flex-direction: column;
                        }

                        .regions-card,
                        .pdi-section {
                            max-width: none;
                            width: 100%;
                        }
                        
                        .operations-depot-section {
                            min-width: auto;
                            max-width: none;
                        }

                        .page-container {
                            padding: 0 !important;
                        }

                        .summary-grid {
                            grid-template-columns: 1fr 1fr;
                            gap: 8px;
                        }

                        .summary-item {
                            padding: 6px;
                        }

                        .summary-label {
                            font-size: 0.8rem;
                        }

                        .summary-value {
                            font-size: 1.1rem;
                        }

                        .depot-title {
                            font-size: 1.3rem;
                            padding: 10px 5px;
                        }

                        .summary-item.empty {
                            display: none;
                        }
                    }

                    @media (max-width: 480px) {
                        .summary-label {
                            font-size: 0.75rem;
                        }

                        .summary-value {
                            font-size: 1rem;
                        }

                        .depot-title {
                            font-size: 1.1rem;
                            padding: 8px 5px;
                        }
                    }

                    /* Operations Specific Styles */
                    .live-circle-indicator {
                        position: fixed;
                        bottom: 20px;
                        right: 20px;
                        width: 32px;
                        height: 32px;
                        background-color: white;
                        border-radius: 50%;
                        border: 2px solid #e9ecef;
                        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        z-index: 9999;
                    }

                    .live-circle-indicator::before {
                        content: '';
                        width: 14px;
                        height: 14px;
                        background-color: #22c55e;
                        border-radius: 50%;
                        animation: pulse 2s infinite;
                        box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.7);
                    }

                    .live-circle-indicator.error::before {
                        background-color: #ef4444;
                        animation: errorPulse 1s infinite;
                        box-shadow: 0 0 0 0 rgba(239, 68, 68, 0.7);
                    }

                    @keyframes pulse {
                        0% {
                            transform: scale(0.95);
                            box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.7);
                        }
                        
                        70% {
                            transform: scale(1);
                            box-shadow: 0 0 0 10px rgba(34, 197, 94, 0);
                        }
                        
                        100% {
                            transform: scale(0.95);
                            box-shadow: 0 0 0 0 rgba(34, 197, 94, 0);
                        }
                    }

                    @keyframes errorPulse {
                        0% {
                            transform: scale(0.95);
                            box-shadow: 0 0 0 0 rgba(239, 68, 68, 0.7);
                        }
                        
                        70% {
                            transform: scale(1);
                            box-shadow: 0 0 0 10px rgba(239, 68, 68, 0);
                        }
                        
                        100% {
                            transform: scale(0.95);
                            box-shadow: 0 0 0 0 rgba(239, 68, 68, 0);
                        }
                    }

                    @media (max-width: 768px) {
                        .live-circle-indicator {
                            position: fixed;
                            bottom: 5px !important;
                            left: 5px;
                            top: auto;
                            right: auto;
                            width: 22px;
                            height: 22px;
                            display: flex !important;
                            z-index: 9999;
                        }

                        .live-circle-indicator::before {
                            content: '';
                            width: 10px !important;
                            height: 10px !important;
                            display: block !important;
                            background-color: #22c55e !important;
                        }
                    }
                `}</style>
            </div>

            {showScrollTop && (
                <Draggable handle='.scroll-to-top-button'
                    allowAnyClick={false}
                    onStart={handleDragStart}
                    onDrag={handleDrag}
                    onStop={handleDragStop}
                >
                    <button className="scroll-to-top-button">
                        <i className="fa fa-arrow-up"></i>
                    </button>
                </Draggable>
            )}

            <style jsx global>{`
                .scroll-to-top-button {
                    position: fixed;
                    bottom: 20px;
                    right: 20px;
                    width: 45px;
                    height: 45px;
                    background: #2B53C6;
                    color: white;
                    border: none;
                    border-radius: 50%;
                    display: none;
                    align-items: center;
                    justify-content: center;
                    font-size: 18px;
                    cursor: pointer;
                    z-index: 1000;
                    box-shadow: 0 4px 12px rgba(43, 83, 198, 0.3);
                    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
                    opacity: 0.8;
                    backdrop-filter: blur(10px);
                    transform: translateY(0);
                }

                .scroll-to-top-button:hover {
                    background: #1e40af;
                    transform: translateY(-3px);
                    box-shadow: 0 6px 16px rgba(43, 83, 198, 0.4);
                    opacity: 1;
                }

                .scroll-to-top-button:active {
                    transform: translateY(0);
                    box-shadow: 0 2px 8px rgba(43, 83, 198, 0.3);
                }

                .scroll-to-top-button i {
                    transition: transform 0.3s ease;
                }

                .scroll-to-top-button:hover i {
                    transform: translateY(-2px);
                }

                @media (max-width: 768px) {
                    .scroll-to-top-button {
                        display: flex;
                        bottom: 30px;
                        width: 40px;
                        height: 40px;
                        font-size: 16px;
                        background: rgba(43, 83, 198, 0.8);
                    }

                    .scroll-to-top-button:hover {
                        background: rgba(43, 83, 198, 1);
                    }
                }
            `}</style>
        </>
    );
};

export default OperasyonTakip;